/**
 * Convert mouse event coordinates to logical canvas coordinates.
 * Accounts for both CSS scaling and HiDPI backing store scaling.
 */
export function getCanvasCoordinates(
    canvas: HTMLCanvasElement,
    event: MouseEvent
): { x: number; y: number } {
    const rect = canvas.getBoundingClientRect();
    const scaleFactor = Number(canvas.dataset.scaleFactor) || 1;
    const scaleX = canvas.width / (rect.width * scaleFactor);
    const scaleY = canvas.height / (rect.height * scaleFactor);
    return {
        x: (event.clientX - rect.left) * scaleX,
        y: (event.clientY - rect.top) * scaleY
    };
}
